import Link from 'next/link'
import { useParams } from 'next/navigation'
import { useTimer } from 'react-timer-hook'
import SolidButton from '@/components/Common/Button/SolidButton'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/lib/stores/authStore'

const ApplyForm = ({ endAt, isKtpDomain = false }: { endAt: string; isKtpDomain?: boolean }) => {
  const params = useParams()
  const id = params.id as string
  const expiryTimestamp = new Date(endAt)
  const { t } = useTranslation('common')
  const { user } = useAuthStore()

  const { minutes, hours, days, seconds } = useTimer({
    expiryTimestamp: expiryTimestamp,
    onExpire: () => console.warn('onExpire called'),
  })

  const isLeftApplyDurationOneDays = days === 0

  const pad2 = (value: number) => String(value).padStart(2, '0')
  const remainTimeText = isLeftApplyDurationOneDays
    ? `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`
    : `${days}${t('cta.applyForm.dayShort')} ${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`

  return (
    <>
      <div className="flex items-center justify-center">
        {isKtpDomain ? (
          <p className="text-sm font-semibold text-white lg:text-lg">
            협력과제 확인하고 프로그램에 참여해보세요
          </p>
        ) : (
          <p
            className="text-sm font-semibold text-normal lg:text-lg"
            dangerouslySetInnerHTML={{
              __html: t('cta.applyForm.message', {
                time: `<span class='text-primary-normal'>${remainTimeText}</span>`,
              }),
            }}
          />
        )}
      </div>
      <div className={`w-full ${isKtpDomain ? 'lg:max-w-[175px]' : 'lg:max-w-[160px]'}`}>
        <Link href={user ? `/${id}/apply` : `/login?prev=${encodeURIComponent(`/${id}/apply`)}`}>
          <SolidButton
            className={`!h-10 !w-full lg:!h-11 ${isKtpDomain ? '!bg-white !text-[#3385FF] !whitespace-nowrap' : ''}`}>
            {isKtpDomain ? '프로그램 신청하기' : t('cta.applyForm.button')}
          </SolidButton>
        </Link>
      </div>
    </>
  )
}

export default ApplyForm
